module.exports = __webpack_public_path__ + "static/media/facilimg2.395e8d36.jpg";